var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.333 3.999a.724.724 0 0 1-.47-.168L4 1.38 1.138 3.833a.747.747 0 0 1-.943 0 .516.516 0 0 1 0-.808L3.528.167a.747.747 0 0 1 .943 0l3.333 2.858c.26.223.26.584 0 .808-.129.11-.3.166-.47.166Z",
    fill: "currentColor"
  })));
};

export default SvgArrowUp;